import React from "react";

import AdvicePng from "../../../Assets/AdvicePng.png";
import ConnectPng from "../../../Assets/ConnectPng.png";
import DiagnosticsPng from "../../../Assets/DiagnosticsPng.png";
import PricingPng from "../../../Assets/PricingPng.png";
import HowItWorksInfoCard from "../../Cards/HowItWorksInfoCard";

const HowItWorks = () => {
  const steps = [
    {
      icon: AdvicePng,
      title: "ADVICE",
      description:
        "Harness the power of AI to get instant answers to any of your tree care questions.",
    },
    {
      icon: DiagnosticsPng,
      title: "DIAGNOSTICS",
      description:
        "Upload photos of your trees and let us help you diagnose pests, diseases, and make specific recommendations tailored for you and your trees.",
    },
    {
      icon: PricingPng,
      title: "PRICING",
      description:
        "Access our Dynamic Pricing Engine. Gone are the days of guessing how much tree work will cost. Our pricing tool takes out the guesswork and helps you find out exactly how much you can expect to pay for tree work.",
    },
    {
      icon: ConnectPng,
      title: "CONNECT",
      description:
        "Connect with tree care professionals like never before. Use our Arborist Connect platform to help you find and hire the right professionals for your tree work.",
    },
  ];

  return (
    <section className="bg-[#f8f5f0] py-16 relative">
      <div className="container mx-auto px-4">
        <h2 className="heading text-[#0b3d2c]">
          HOW IT WORKS
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index}>
              <HowItWorksInfoCard
                icon={step.icon}
                title={step.title}
                description={step.description}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
